module.exports = __webpack_public_path__ + "img/ep-K.eea980f9.jpg";